import {Component, Input} from '@angular/core';
import {SortDataColumn} from "../../../../models/table.model";
import {SortTableService} from "../../../../services/sort-table.service";
import {PercentDataPosDto} from "../../models/virtual-cash.models";

@Component({
  selector: 'app-commission-virtual-cash-dialog',
  templateUrl: './commission-virtual-cash-dialog.component.html',
  styleUrls: ['./commission-virtual-cash-dialog.component.scss']
})
export class CommissionVirtualCashDialogComponent {
  @Input() percentData: PercentDataPosDto[] | undefined

  sortColumnData: SortDataColumn | undefined

  constructor(
    private sortTableService: SortTableService,
  ) {
  }

  sortColumn(column: string) {
    this.sortColumnData = this.sortTableService.sort(column)
  }
}
